export function areEqual(array1, array2) {
  return (array1.length === array1.length) && array1.every((element, index) => element === array2[index])
}

export function remove(array, obj) {
  const index = array.indexOf(obj)
  if (index > -1) {
    array.splice(index, 1)
  }
  return array
}

export function handleCheckbox(currentElements, newElement, setter) {
  if (currentElements.includes(newElement)) {
    const newElementsList = remove(currentElements, newElement)
    setter([...newElementsList])
  } else {
    const newElementsList = [...currentElements]
    newElementsList.push(newElement)
    setter([...newElementsList])
  }
}

export function isNullOrEmpty(arr) {
  return !arr || !arr.length
}
